import { render, staticRenderFns } from "./aiDesign.vue?vue&type=template&id=2bf2b846&scoped=true"
import script from "./aiDesign.vue?vue&type=script&lang=js"
export * from "./aiDesign.vue?vue&type=script&lang=js"
import style0 from "./aiDesign.vue?vue&type=style&index=0&id=2bf2b846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2b846",
  null
  
)

export default component.exports